var _Defs, _ClipPath, _Path, _Path2, _Path3, _Path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Defs, Path, ClipPath, Use } from "react-native-svg";
function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 64,
    height: 64
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Path, {
    id: "google-logo_svg__a",
    d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
  }))), _ClipPath || (_ClipPath = /*#__PURE__*/React.createElement(ClipPath, {
    id: "google-logo_svg__b"
  }, /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#google-logo_svg__a"
  }))), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M0 37V11l17 13z",
    clipPath: "url(#google-logo_svg__b)",
    fill: "#fbbc05",
    transform: "matrix(.72727 0 0 .72727 -.955 -1.455)"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M0 11l17 13 7-6.1L48 14V0H0z",
    clipPath: "url(#google-logo_svg__b)",
    fill: "#ea4335",
    transform: "matrix(.72727 0 0 .72727 -.955 -1.455)"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M0 37l30-23 7.9 1L48 0v48H0z",
    clipPath: "url(#google-logo_svg__b)",
    fill: "#34a853",
    transform: "matrix(.72727 0 0 .72727 -.955 -1.455)"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M48 48L17 24l-4-3 35-10z",
    clipPath: "url(#google-logo_svg__b)",
    fill: "#4285f4",
    transform: "matrix(.72727 0 0 .72727 -.955 -1.455)"
  })));
}
export default SvgGoogleLogo;